import { render, staticRenderFns } from "./moveGarbage.vue?vue&type=template&id=95abcc20&scoped=true"
import script from "./moveGarbage.vue?vue&type=script&lang=js"
export * from "./moveGarbage.vue?vue&type=script&lang=js"
import style0 from "./moveGarbage.vue?vue&type=style&index=0&id=95abcc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95abcc20",
  null
  
)

export default component.exports